import React, { useRef } from 'react';
import { useDispatch } from "react-redux";
import { DragDropContext } from "react-beautiful-dnd";
import { Col } from "react-bootstrap";
import Columns from '../Column/Columns';
import { moveColumn, moveCard } from '../../../actions/scout-kanban';
import GeoRegionList from '../geoRegion/GeoRegionList';
import FarmUserList from '../users/FarmUserList';
const BoardBody = () => {
    const kanbanWrapper = useRef();
    const dispatch = useDispatch();
    const onDragEnd = result => {
        const { source, destination, type, draggableId } = result;
        if (!destination) return;

        if (type === "column") {
            dispatch(moveColumn({
                oldColumnIndex: source.index,
                newColumnIndex: destination.index
            }));
            return;
        }

        if (source.droppableId === "geoRegion") {
            dispatch(moveCard({
                oldCardIndex: source.index,
                newCardIndex: destination.index,
                sourceScoutGroupId: source.droppableId,
                destScoutGroupId: destination.droppableId,
                scoutMemberId: draggableId
            }));
            return;
        }

        if (source.droppableId === "farmusers") {
            dispatch(moveCard({
                oldCardIndex: source.index,
                newCardIndex: destination.index,
                sourceScoutGroupId: source.droppableId,
                destScoutGroupId: destination.droppableId,
                scoutMemberId: draggableId
            }));
            return;
        }

        dispatch(moveCard({
            oldCardIndex: source.index,
            newCardIndex: destination.index,
            sourceScoutGroupId: source.droppableId,
            destScoutGroupId: destination.droppableId,
            scoutMemberId: draggableId
        }));
    }

    // const onBeforeCapture = before => {
    //     console.log("before", before);
    // }

    // const onDragStart = ({ type }) => {
    //     console.log("type", type);
    // }

    return (
        <DragDropContext /* onBeforeCapture={onBeforeCapture} onDragStart={onDragStart} */ onDragEnd={onDragEnd}>
            <div className="kanban-body kanban-columns row" ref={kanbanWrapper} >
                <Col lg={10} className="m-0">
                    <Columns />
                </Col>
                <Col lg={2} className="m-0 scout_column-wrap kanban-column-wrap kanban-column-fixed crewDrag_container">
                    <GeoRegionList />
                    <FarmUserList />
                </Col>
            </div>
        </DragDropContext>
    )
}

export default BoardBody;